import { render, staticRenderFns } from "./CreateProduceReportButton.vue?vue&type=template&id=0d4f8b07&"
import script from "./CreateProduceReportButton.vue?vue&type=script&lang=js&"
export * from "./CreateProduceReportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports